<mat-checkbox
    #nativeElement

    (change)="changeValue($event)"

    [color]="asFormsControl().color"
    [checked]="asFormsControl().getChecked()"
    [disabled]="asFormsControl().disabled || disabled"
    [ngClass]="{'fluid-text-between': fluidBetween}"

    class="d-block"
>
    <ng-content select="[text]"></ng-content>
</mat-checkbox>
